// https://en.wikipedia.org/wiki/ISO_4217
export enum Currency {
  EUR = 'EUR',
  USD = 'USD',
  GBP = 'GBP',
}
